/* eslint-disable @typescript-eslint/no-non-null-assertion */
import '../../../webmodule-common/other/ui/maps/google-map';
import '../../../webmodule-common/other/ui/maps/google-place-autocomplete';
import { Branch, Franchisee } from '../../api/dealer-api-interface-franchisee';
import { createBranch } from '../editors/franchisee-branches-editor';
import { customElement, state } from 'lit/decorators.js';
import { EventTemplate, Snippet } from '../../../webmodule-common/other/ui/events';
import { getApiFactory } from '../../api/api-injector';
import { html } from 'lit';
import { PageControlTabWithIndependantSaving } from '../../../webmodule-common/other/ui/data-entry-screen-base';
import { refreshButton } from '../../../webmodule-common/other/ui/command-action';
import { tlang } from '../../../webmodule-common/other/language/lang';
import { userDataStore } from '../../dealer-franchisee/common/current-user-data-store';
import { userSecurity } from '../../../webmodule-common/other/api/user-security';

@customElement('wm-franchiseeinformationview')
export class FranchiseeInformationView extends PageControlTabWithIndependantSaving {
  @state()
  private branches: Branch[] = [];
  constructor() {
    super();
    this.pageFragment = 'information';
  }

  get franchisee(): Franchisee {
    return userDataStore.franchisee;
  }

  get isAdmin() {
    return userSecurity().isAdmin() || userSecurity().isSupplier();
  }

  public isDataReadonly(): boolean {
    return !this.isAdmin;
  }

  buttonMenu() {
    const createBranchEvent = () => {
      this.createBranch();
    };
    return html` <webmodule-button
        size="small"
        variant="primary"
        ?disabled=${this.isDataReadonly()}
        @click=${createBranchEvent}
      >
        ${tlang`Create %%branch%%`} </webmodule-button
      >${refreshButton(() => this.reloadBranches())}`;
  }

  async createBranch() {
    const b = await createBranch();

    if (b) await this.reloadBranches();
  }
  async reloadBranches() {
    this.branches = (await getApiFactory().franchisee().getBranches())?.branches ?? [];
  }
  public async afterConstruction(): Promise<void> {
    await this.reloadBranches();
  }
  public internalDataChanged(): boolean {
    return false;
  }

  public async prepareForSave(): Promise<void> {
    //
  }

  public allowDeletePage(): boolean {
    return false;
  }

  protected getCaption(): Snippet {
    return tlang`%%franchisee%% !!branch!!`;
  }

  protected async internalSaveData(): Promise<boolean> {
    return true;
  }

  protected bodyTemplate(): EventTemplate {
    const branchChangedEvent = (e: CustomEvent<{ branch: Branch }>) => {
      e.stopImmediatePropagation();
      this.reloadBranches();
    };

    return html`
      <div class="row ">
        <h1 class="text-primary">${this.franchisee.name}</h1>
        <wm-franchisee-branches-editor
          .data=${this.branches}
          @wm-be-changed=${branchChangedEvent}
          .readonly=${this.isDataReadonly()}
        >
        </wm-franchisee-branches-editor>
      </div>
    `;
  }
}
